import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { createStructuredSelector } from "reselect";
import {
  makeSelectData,
  makeSelectTransfers,
  makeSelectMoney,
  makeSelectOptions,
  makeSelectLoading,
  makeSelectError,
  makeSelectInfo
} from "./selectors";
import { PanelGroup, Panel } from "react-bootstrap";
import PanelHeading from "./PanelHeading/index";
import TransferOptionsPanel from "./TransferOptionsPanel";
import TravelDetailsPanel from "./TravelDetailsPanel";
import YourSummaryPanel from "./YourSummaryPanel";
import {
  fetchBasketData,
  postBasketData,
  changeBasketCurrency
} from "../../actions/basket";
import {
  fetchHelpData,
  fetchSeatTypesData,
  fetchChildAgesData
} from "../../actions/info";
import Scroll from "react-scroll"; //Imports all mixin
import moment from "moment";
import { change } from "redux-form";
import 'rc-dialog/assets/index.css';
import Dialog from "rc-dialog"
import "./styles.css";

type Props = {
  fetchBasketData: Function,
  postBasketData: Function,
  changeBasketCurrency: Function,
  basketData: any,
  initialInboundValues: any,
  onSelect: Function,
  match: Object,
  transfers: Object,
  loading: boolean,
  options: Object,
  money: Object,
  error: boolean
};

type State = {
  activeKey: string,
  openTransferOptions: boolean
};
let Element = Scroll.Element;

class QuotePage extends React.Component<Props, State> {
  state: State;
  constructor() {
    super();
    this.state = {
      activeKey: "1",
      openTransferOptions: true,
      visible: false,
      loadingClick: false
    };
  }

  componentWillUpdate(nextProps) {
    const { transfers } = this.props;
    if (
      transfers &&
      transfers[0] &&
      nextProps.transfers &&
      !nextProps.errorMessages
    ) {
      const prevChildrenOutbound = transfers[0].children.length;
      if (prevChildrenOutbound > nextProps.transfers[0].children.length) {
        for (let i = 0; i < prevChildrenOutbound; i++) {
          this.props.change(
            "transferDetailsOutboundForm",
            `childAge${i + nextProps.transfers[0].children.length}`,
            false
          );
          this.props.change(
            "transferDetailsOutboundForm",
            `seatType${i + nextProps.transfers[0].children.length}`,
            false
          );
        }
      } else if (transfers[0].children.length > 0) {
        for (let i = 0; i < nextProps.transfers[0].children.length; i++) {
          this.props.change(
            "transferDetailsOutboundForm",
            `childAge${i}`,
            nextProps.transfers[0].children[i].age
          );
          this.props.change(
            "transferDetailsOutboundForm",
            `seatType${i}`,
            nextProps.transfers[0].children[i].seatType.code
          );
        }
      }
      if (transfers[1]) {
        if (transfers[1] && nextProps.transfers[1].children.length > 0) {
          //&& !this.props.error
          const prevChildrenInbound = transfers[1].children.length;
          if (prevChildrenInbound > nextProps.transfers[1].children.length) {
            for (let i = 0; i < prevChildrenInbound - 1; i++) {
              this.props.change(
                "transferDetailsInboundForm",
                `childAge${i + prevChildrenInbound - 1}`,
                null
              );
              this.props.change(
                "transferDetailsInboundForm",
                `seatType${i + prevChildrenInbound - 1}`,
                null
              );
            }
          }

          for (let i = 0; i < nextProps.transfers[1].children.length; i++) {
            this.props.change(
              "transferDetailsInboundForm",
              `childAge${i}`,
              nextProps.transfers[1].children[i].age
            );
            this.props.change(
              "transferDetailsInboundForm",
              `seatType${i}`,
              nextProps.transfers[1].children[i].seatType.code
            );
          }
        }
        this.props.change(
          "transferDetailsInboundForm",
          "firstName",
          nextProps.transfers[1].forename
        );
        this.props.change(
          "transferDetailsInboundForm",
          "lastName",
          nextProps.transfers[1].surname
        );
        this.props.change(
          "transferDetailsInboundForm",
          "accommodationName",
          nextProps.transfers[1].fromAccommodation.name
        );
        this.props.change(
          "transferDetailsInboundForm",
          "accommodationAddress",
          nextProps.transfers[1].fromAccommodation.street
        );
        this.props.change(
          "transferDetailsInboundForm",
          "toAccommodationName",
          nextProps.transfers[1].toAccommodation.name
        );
        this.props.change(
          "transferDetailsInboundForm",
          "toAccommodationAddress",
          nextProps.transfers[1].toAccommodation.street
        );

        this.props.change(
          "transferDetailsInboundForm",
          "phone",
          nextProps.transfers[1].mobile
        );
        this.props.change(
          "transferDetailsInboundForm",
          "email",
          nextProps.transfers[1].email
        );
        this.props.change(
          "transferDetailsInboundForm",
          "skiSnowboards",
          nextProps.transfers[1].numberOfSkis
        );
        this.props.change(
          "transferDetailsInboundForm",
          "holdLuggage",
          nextProps.transfers[1].numberOfHoldItems
        );
        this.props.change(
          "transferDetailsInboundForm",
          "bikesSurfboards",
          nextProps.transfers[1].numberOfBikes
        );
        this.props.change(
          "transferDetailsInboundForm",
          "notes",
          nextProps.transfers[1].notes
        );
        this.props.change(
          "transferDetailsInboundForm",
          "flying",
          nextProps.transfers[1].flightTimeOverride
        );
      }
    }
  }

  componentDidMount() {
    localStorage.setItem("catchExit", "1")
    let guid = this.props.match.params.id
    if(guid.length !== 32){
      guid = localStorage.getItem("guid");
    }
    this.props.fetchBasketData(guid).then(result => {
      if(result.type === "API_DATA_FAILURE"){
        this.setState({ visible: true });
      }
    });
    window.addEventListener("beforeunload", this.beforeunload.bind(this));
    this.props.fetchBasketData(this.props.match.params.id);
    this.props.fetchHelpData(this.props.match.params.id); //.then(result => console.log(result));
    this.props.fetchSeatTypesData(); //.then(result => console.log(result));
    this.props.fetchChildAgesData(); //.then(result => console.log(result));
    if (this.props.basketData && this.props.basketData.continueText) {
      this.setState({ activeKey: "4" });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.beforeunload.bind(this));
  }
  componentDidUpdate(prevProps, prevState) {
    setTimeout(() => {
      if (this.state.activeKey === "1" && prevState.activeKey !== "1") {
        Scroll.scroller.scrollTo("TransferOptionsPanel", {
          duration: 1500,
          offset: -100,
          delay: 0,
          smooth: "easeInOutQuint"
        });
      }
      if (this.state.activeKey === "2" && prevState.activeKey !== "2") {
        Scroll.scroller.scrollTo("TravelDetailsPanel", {
          duration: 1500,
          delay: 0,
          smooth: "easeInOutQuint"
        });
      }
      if (this.state.activeKey === "3" && prevState.activeKey !== "3") {
        Scroll.scroller.scrollTo("YourSummaryPanel", {
          duration: 1500,
          delay: 0,
          smooth: "easeInOutQuint"
        });
      }
    }, 300);
    if (this.state.activeKey === "4") {
      this.setState({ activeKey: "1" });
    }
  }

  handleSelect = (activeKey: string) => {
    if(activeKey === "3" ){
      this.setState.loadingClick = true;
    }
    this.setState({ activeKey });
  };

  handleToggle = (activeKey: string) => {
    if (activeKey === this.state.activeKey) {
      this.setState({ activeKey: "0" });
    }
  };
  HandleCurrencyChange = (activeCurrency: string) => {
    this.props.changeBasketCurrency(this.props.basketData.id, activeCurrency);
  };
  beforeunload(event) {
    
    this.props
      .postBasketData(null, null, null, true, true)
      .then(response => {
        if (response.result === "error") {
          throw Error(response.message);
        }
      })
      .catch(() => console.error("error saving cart please contact Admin"));

  }
  onClose = (e: React.SyntheticEvent) => {
    localStorage.setItem("catchExit", "0")
    this.setState({
      visible: false,
    });
    window.location.href = "https://www.ski-lifts.com/";
  }
  render() {
    let { transfers } = this.props;
    let childAgesOutbound = [];
    let childAgesInbound = [];
    let childSeatOutbound = [];
    let childSeatInbound = [];
    let initialOutboundValues = undefined;
    let initialInboundValues = undefined;
    if (transfers && transfers[0].date) {
      const outboundTransfers = transfers[0];
      const {
        id,
        date,
        children,
        mobile,
        numberOfBikes,
        numberOfHoldItems,
        numberOfSkis,
        surname,
        time,
        forename,
        email,
        fromDestination,
        toDestination,
        notes,
        adults,
        transferType,
        flightNumber,
        fromAccommodation,
        toAccommodation,
        flightTimeOverride,
        shuttle
      } = outboundTransfers;

      childAgesOutbound = children.reduce((obj, val, index) => {
        obj[`childAge${index}`] = val.age;
        return obj;
      }, {});

      childSeatOutbound = children.reduce((obj, val, index) => {
        obj[`seatType${index}`] = val.seatType.code;
        return obj;
      }, {});

      initialOutboundValues = {
        id,
        from: toDestination.name,
        to: fromDestination.name,
        transferType: transferType.description,
        date: moment(date).format("Do MMMM YYYY"),
        time: time,
        flightNumber: flightNumber,
        adults: adults,
        children: children.length,
        skiSnowboards: numberOfSkis,
        bikesSurfboards: numberOfBikes,
        holdLuggage: numberOfHoldItems,
        phone: mobile,
        firstName: forename,
        lastName: surname,
        email: email,
        busNumber: shuttle.showTimes ? shuttle.bus.id : "",
        departureStop: shuttle.showFrom ? shuttle.departureStop.id : "",
        arrivalStop: shuttle.showTo ? shuttle.arrivalStop.id : "",
        accommodationName: fromAccommodation.name,
        accommodationAddress: fromAccommodation.street,
        toAccommodationName: toAccommodation.name,
        toAccommodationAddress: toAccommodation.street,
        notes: notes,
        flying: flightTimeOverride,
        ...childAgesOutbound,
        ...childSeatOutbound
      };

      if (transfers && transfers.length === 2) {
        const inboundTransfers = transfers[1];

        const {
          id: idInbound,
          date: dateInbound,
          children: childrenInbound,
          mobile: mobileInbound,
          numberOfBikes: numberOfBikesInbound,
          numberOfHoldItems: numberOfHoldItemsInbound,
          numberOfSkis: numberOfSkisInbound,
          surname: surnameInbound,
          time: timeInbound,
          forename: foreNameInbound,
          email: emailInbound,
          fromDestination: fromDestinationInbound,
          toDestination: toDestinationInbound,
          notes: notesInbound,
          adults: adultsInbound,
          transferType: transfer_typeInbound,
          flightNumber: flight_numberInbound,
          shuttle: shuttleInbound,
          fromAccommodation: fromAccommodationInbound,
          toAccommodation: toAccommodationInbound,
          flying: flightTimeOverrideInbound
        } = inboundTransfers;

        childAgesInbound = childrenInbound.reduce((obj, val, index) => {
          obj[`childAge${index}`] = val.age;
          return obj;
        }, {});

        childSeatInbound = childrenInbound.reduce((obj, val, index) => {
          obj[`seatType${index}`] = val.seatType.code;
          return obj;
        }, {});

        initialInboundValues = {
          id: idInbound,
          to: toDestinationInbound.name,
          from: fromDestinationInbound.name,
          transferType: transfer_typeInbound.description,
          date: moment(dateInbound).format("Do MMMM YYYY"),
          time: timeInbound,
          flightNumber: flight_numberInbound,
          adults: adultsInbound,
          children: childrenInbound.length,
          skiSnowboards: numberOfSkisInbound,
          bikesSurfboards: numberOfBikesInbound,
          holdLuggage: numberOfHoldItemsInbound,
          phone: mobileInbound,
          firstName: foreNameInbound,
          lastName: surnameInbound,
          email: emailInbound,
          busNumber: shuttleInbound.showTimes ? shuttleInbound.bus.id : "",
          departureStop: shuttleInbound.showFrom
            ? shuttleInbound.departureStop.id
            : "",
          arrivalStop: shuttleInbound.showTo
            ? shuttleInbound.arrivalStop.id
            : "",
          accommodationName: fromAccommodationInbound.name,
          accommodationAddress: fromAccommodationInbound.street,
          toAccommodationName: toAccommodationInbound.name,
          toAccommodationAddress: toAccommodationInbound.street,
          notes: notesInbound,
          flying: flightTimeOverrideInbound,
          ...childAgesInbound,
          ...childSeatInbound
        };
      }
    }
    if(this.props.loading && this.setState.loadingClick ){
      this.setState.loadingClick = false;
    }
    return (
      <div className="quotepage-accordion">
        <Dialog
        visible={this.state.visible}
        animation="zoom"
        maskAnimation="fade"
        onClose={this.onClose}
        focusTriggerAfterClose={false}
      >
        <h3>Something Went Wrong</h3>
        <p>You will be redirected to the home page to start a new search</p>
        <button onClick={this.onClose}>OK</button>

       
      </Dialog>

     { this.props.loading && !this.state.visible ? (<div className="spinner"> <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw" /></div>) : null }
     { this.props.loading || this.setState.loadingClick ? (<div className="spinner"> <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw" /></div>) : null }
        <PanelGroup
          activeKey={this.state.activeKey}
          onSelect={this.handleSelect}
          accordion
          id="test"
        >
          <Panel
            eventKey="1"
            onToggle={() => this.handleToggle("1")}
            expanded={this.state.activeKey === "1"}
          >
            <Element name="TransferOptionsPanel" />
            <PanelHeading
            center= {true}
              left="1"
              title="Choose Your Transfer"
              activeKey={this.state.activeKey} 
              hidden={this.state.activeKey !== "1"}
            />
            <Panel.Body collapsible>
              <TransferOptionsPanel
                onSelect={() => this.handleSelect("2")}
                options={this.props.options}
                onCurrencyChange={c => this.HandleCurrencyChange(c)}
                basketId={this.props.basketData.id}
                transfers={this.props.transfers}
                qID={this.props.match.params.id}
              />
            </Panel.Body>
          </Panel>
          <Panel
            eventKey="2"
            className="travel-details"
            onToggle={() => this.handleToggle("2")}
            expanded={this.state.activeKey === "2"}
          >
            <Element name="TravelDetailsPanel" />
            <PanelHeading
              left="2"
              title="Provide Your Booking Details"
              center= {true}
              activeKey={this.state.activeKey}
              hidden={this.state.activeKey !== "2"}
            />
            <Panel.Body collapsible>
              <TravelDetailsPanel
                onSelect={() => this.handleSelect("3")}
                activeKey={this.state.activeKey}
                transfers={this.props.transfers}
                basketId={this.props.basketData.id}
                qID={this.props.match.params.id}
                info={this.props.info}
                initialInboundValues={initialInboundValues}
                initialOutboundValues={initialOutboundValues}
              />
            </Panel.Body>
          </Panel>
          <Panel
            eventKey="3"
            onToggle={() => this.handleToggle("3")}
            expanded={this.state.activeKey === "3"}
          >
            <Element name="YourSummaryPanel" />
            <PanelHeading
              left="3"
              title="Your Summary"
              center= {true}
              activeKey={this.state.activeKey}
              hidden={this.state.activeKey !== "3"}
            />
            <Panel.Body collapsible>
              {this.state.activeKey === "3" ? (
                <YourSummaryPanel
                  activeKey={this.state.activeKey}
                  transfers={this.props.transfers}
                  basketId={this.props.basketData.id}
                  options={this.props.options}
                  initialInboundValues={initialInboundValues}
                  initialOutboundValues={initialOutboundValues}
                  money={this.props.money}
                  info={this.props.info}
                  continueText={this.props.basketData.continueText}
                  postBasketData={this.props.basketData}
                  showCost={this.props.basketData.showCost}
                  qID={this.props.match.params.id}
                />
              ) : null}
            </Panel.Body>
          </Panel>
        </PanelGroup>
      </div>
    );
  }
}
const errorMessages = state => state.errorMessages.hasFailed;
const mapStateToProps = createStructuredSelector({
  basketData: makeSelectData(),
  transfers: makeSelectTransfers(),
  money: makeSelectMoney(),
  options: makeSelectOptions(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  info: makeSelectInfo(),
  errorMessages
});

export default withRouter(
  connect(mapStateToProps, {
    fetchBasketData,
    postBasketData,
    changeBasketCurrency,
    fetchHelpData,
    change,
    fetchSeatTypesData,
    fetchChildAgesData
  })(QuotePage)
);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/index.js